import { render, staticRenderFns } from "./ItemListViewCards.vue?vue&type=template&id=3fd96b43&scoped=true"
import script from "./ItemListViewCards.vue?vue&type=script&lang=ts"
export * from "./ItemListViewCards.vue?vue&type=script&lang=ts"
import style0 from "./ItemListViewCards.vue?vue&type=style&index=0&id=3fd96b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd96b43",
  null
  
)

export default component.exports